var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6299 4.44H4.62994C3.51994 4.44 2.63994 5.33 2.63994 6.44L2.62994 18.44C2.62994 19.55 3.51994 20.44 4.62994 20.44H20.6299C21.7399 20.44 22.6299 19.55 22.6299 18.44V6.44C22.6299 5.33 21.7399 4.44 20.6299 4.44ZM20.6299 18.44H4.62994V12.44H20.6299V18.44ZM20.6299 8.44H4.62994V6.44H20.6299V8.44Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.f5ff3fc85cceccf31e0de98051e39a26.svg";
export { ForwardRef as ReactComponent };